import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.custom.background.area,
    color: theme.palette.custom.feedback.positive,
    border: `solid 1px ${fade(theme.palette.custom.feedback.positive, 0.38)}`,
    borderRadius: theme.shape.borderRadius,
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(3),

    '& .certificate': {
      '&-content': {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        minHeight: theme.spacing(5),
        width: '100%',
        padding: theme.spacing(0, 1),
        backgroundColor: fade(theme.palette.custom.feedback.positive, 0.08),
      },
      '&-icon': {
        color: theme.palette.custom.feedback.positive,
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      '&-text': {
        '&-container': {
          display: 'flex',
          alignItems: 'center',
          flexGrow: 1,
          overflow: 'hidden',
          padding: theme.spacing(0, 2, 0, 1),

          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            margin: theme.spacing(1, 0),
          },
        },
        '&-title': {
          display: 'flex',
          flexGrow: 1,
          justifyContent: 'flex-start',
          fontWeight: theme.typography.fontWeightMedium,
          textAlign: 'left',
          color: theme.palette.custom.feedback.positive,
        },
      },
    },
    '&:hover': {
      '& .certificate': {
        '&-content': {
          backgroundColor: fade(theme.palette.custom.feedback.positive, 0.16),
        },
      },
    },
  },
}));

export default styles;
